import { Injectable } from '@angular/core';
import { LOCAL_STORAGE } from '@core-utils';

@Injectable()
export class TableWidthPersistenceService {
  save(tableId: string, widths: Map<string, number>, order: string[]): void {
    const payload = {
      widths: [...widths],
      order,
    };
    localStorage.setItem(
      `${LOCAL_STORAGE.TABLE_COLUMN_WIDTHS_PREFIX}-${tableId}`,
      JSON.stringify(payload),
    );
  }

  load(
    tableId: string,
  ): { widths: Map<string, number>; order: string[] } | null {
    const raw = localStorage.getItem(
      `${LOCAL_STORAGE.TABLE_COLUMN_WIDTHS_PREFIX}-${tableId}`,
    );
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    return {
      widths: new Map<string, number>(parsed.widths ?? []),
      order: parsed.order ?? [],
    };
  }
}
